import ga from 'app/common/lib/ga';
import ResourceFactory from 'app/common/lib/ResourceFactory';

export function blockUser(userId) {
  const resource = ResourceFactory.create('UserBlockResource', {
    blocked_user_id: userId,
  });
  const GACategory = 'user_block';

  return resource.callCreate().then(
    () => {
      ga.trackEvent(GACategory, PCONST.GA_ACTION_SUCCESS);
    },
    () => {
      ga.trackEvent(GACategory, PCONST.GA_ACTION_ERROR);
    },
  );
}

/**
 * An util function to make a callDelete resource call.
 *
 * @param {Object} resourceOptions the resource name and options
 * @param {string} GACategory  the name of the GA event
 * @param {Object} pubsubParams  pubsub topic to publish
 * @return {Promise}
 */
function resourceDeleteCall(resourceOptions, GACategory) {
  const resource = ResourceFactory.create(resourceOptions.name, resourceOptions.options);

  if (!resource) {
    return Promise.reject(new Error(resource.getName() + ' was not created'));
  }

  return resource.callDelete().then(
    () => {
      if (GACategory) {
        ga.trackEvent(GACategory, PCONST.GA_ACTION_SUCCESS);
      }

      return Promise.resolve();
    },
    () => {
      if (GACategory) {
        ga.trackEvent(GACategory, PCONST.GA_ACTION_ERROR);
      }
      return Promise.reject(new Error(resource.getName() + ' failed to call callDelete()'));
    },
  );
}

export function leaveBoard(boardId, userId) {
  const boarCollabResourceOptions = {
    name: 'BoardCollaboratorResource',
    options: {
      board_id: boardId,
      invited_user_id: userId,
      ban: false,
    },
  };

  return resourceDeleteCall(boarCollabResourceOptions, 'collaborator_delete_invite');
}
